import type { FC } from 'react';
import { useEffect } from 'react';
import clsx from 'clsx';

import Avatar from '@trend-dev/trendtech-ui/components/UI/Avatar';
import { Icon } from '@trend-dev/ui-libs-icons';

import type { TLocation } from 'store/conference/helpers/getVideoContainerId';
import { getVideoContainerId } from 'store/conference/helpers/getVideoContainerId';
import type { IUser } from 'store/declare';

import styles from './styles.module.scss';

interface IProps extends Pick<IUser, 'avatar' | 'name' | 'id' | 'isCameraEnabled' | 'type'> {
    /** функция для отрисовки видео */
    drawVideoFunction?: () => void;
    /** расположение встраиваемого видео-контента */
    location: TLocation;
}

const MediaContent: FC<IProps> = ({ avatar, drawVideoFunction, id, isCameraEnabled, location, name, type }) => {
    const isCenterLocation = location === 'center';

    const content = () => {
        if (type === 'client') {
            return (
                <div>
                    <Icon name={isCenterLocation ? 'UserBold_30' : 'UserBold_60'} />
                </div>
            );
        }
        if (avatar) {
            return <img src={avatar} alt='' />;
        }

        return (
            <Avatar size={isCenterLocation ? 'xxl' : 'lg'} background='transparent'>
                {name}
            </Avatar>
        );
    };

    useEffect(() => {
        if (isCameraEnabled && drawVideoFunction) {
            drawVideoFunction();
        }
    }, [drawVideoFunction, isCameraEnabled]);

    return (
        <div className={clsx(styles.wrapper, 'media-content')}>
            <div className={clsx(styles.avatarWrapper, 'avatar-wrapper', location)}>
                <div className={styles.avatarElement}>{content()}</div>
            </div>
            <div
                id={getVideoContainerId({ id, location })}
                className={clsx(
                    styles.cameraElement,
                    {
                        [styles.cameraElementHidden]: !isCameraEnabled,
                    },
                    'remote-video-container',
                )}
            />
        </div>
    );
};

export default MediaContent;
